import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../../api/baseUrl";
import BottomTab from "../../../components/pagination/BottomTab";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import Container from "../../../layouts/containers/Container";

function ClinicData() {
  const [data, setdata] = useState([]);
  const [count, setcount] = useState(0);
  const [days, setDays] = useState(7);
  const [page, setpage] = useState(1);
  const navigate = useNavigate();
  const getdata = (pages: any, days: number) => {
    baseUrl
      .get("/admin/dashboad/findClinicData", {
        headers: {
          page: pages,
          days: days,
        },
      })
      .then((response) => {
        setdata(response.data.data);
        setcount(response.data.count);
      })
      .catch((error) => {
        console.error(error.response);
      });
  };
  useEffect(() => {
    getdata(page,days);
  }, []);

  const onPageChange = (e: any) => {
    getdata(e,days);
    setpage(e);
  };
  const onSelect = (e: any) => {
    setDays(e)
    getdata(page,e);
    setpage(page);
  };
  return (
    <CommonLayout>
      <Container>
        <div className="p-2.5 md:p-2.5">
          {/* <div className="w-full flex justify-end">
            <button className="bg-[#174d7a] px-2.5 py-2 rounded text-sm text-white">Add Clinic</button>
          </div> */}
          <div className="flex justify-between items-center mb-4">
            <p className="text-[#2d3748] font-['Work_Sans'] text-base font-semibold uppercase">Clinic List</p>
            <div className="text-[#3182ce] font-['Work_Sans'] text-lg font-bold uppercase">
              <select
                value={days}
                onChange={(e) => onSelect(Number(e.target.value))}
                className="bg-transparent border border-[#3182ce] rounded px-2 py-1 text-[#3182ce] font-bold uppercase cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#3182ce]"
              >
                <option value={1}>today</option>
                <option value={7}>last 7 days</option>
                <option value={30}>last 30 days</option>
              </select>
            </div>
          </div>

          <div className="w-full overflow-x-auto">
            <table className="w-full border-collapse border-spacing-0">
              <thead className="bg-[rgb(250,250,250)] border-t border-b-2 border-[rgb(240,240,240)]">
                <tr>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">Clinic Name</th>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">No Of Patients</th>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">No Of treatments</th>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">No Of appointment</th>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">No Of staffs</th>
                  <th className="text-left py-3 px-3 text-xs font-bold uppercase text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] leading-6">total amount</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any, i: number) => {
                  return (
                    <tr key={i}>
                      <td data-label="Clinic Name" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.clinicName}
                      </td>
                      <td data-label="No Of Patients" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.patients}
                      </td>
                      <td data-label="No Of treatments" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.treatments}
                      </td>
                      <td data-label="No Of appointment" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.appointment}
                      </td>
                      <td data-label="No Of staffs" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.staffs}
                      </td>
                      <td data-label="total amount" className="py-3 px-3 text-sm text-[var(--text-color)] border border-[rgb(240,240,240)] font-['Inter',sans-serif] font-normal leading-[1.66]">
                        {item?.total}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <BottomTab
            title={"Clinics"}
            count={count}
            onPageChange={onPageChange}
          />
        </div>
      </Container>
    </CommonLayout>
  );
}

export default ClinicData;
